import React, {useState} from 'react';
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {formatDate, MOMENT_FORMAT_DATE_DMY_DOTS} from "../../functions/formatters";
import IconButton from "@mui/material/IconButton";
import {HighlightOff} from "@mui/icons-material";
import {actCRUD, resolutionActCRUD} from "../../http";
import {useController, useFieldArray, useFormContext} from "react-hook-form";
import {Button, Dialog, DialogContent, Divider, FormHelperText} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import ActCRUDTable from "../CRUD/Tables/ActCRUDTable";
import {ACT_ROUTE} from "../../routes";
import {useHistory} from "react-router-dom";
import useAlert from '../../hooks/useAlert';
import {
    RESOLUTION_ATTACHMENT_EXTRA_FILTER,
    isEligibleForResolutionAttachment,
} from '../../functions/governmentActEligibility';

function RHFActField({label, disabled = false, governmentActsOnly = false}) {
    const {control} = useFormContext();
    const {fieldState: {error}} = useController({name: 'acts'});
    const {field: {onChange}} = useController({name: 'targetObject'});
    const {field: {onChange: onChangeFilial}} = useController({name: 'filialId'});
    const {field: {onChange: onChangeFilialDivision}} = useController({name: 'filialDivisionId'});
    const {push} = useHistory()
    const alert = useAlert(false, 1);

    const {fields, append, remove} = useFieldArray({
        control,
        name: 'acts',
        keyName: 'fieldKey',
    });


    const deleteColumnStyles = {
            position: "sticky",
            right: 0,
        },
        cellHeadStyles = {fontWeight: "bold", fontSize: 14};

    function deleteActHandler(id) {
        const index = fields.findIndex(el => el.actId === id)
        remove(index);
    }

    const [open, setOpen] = useState(false)

    const handleGoToAct = async (actId) => {
        debugger;
        let act;
        act = await actCRUD.get(actId);

        let form = act?.form;
        if (!form)
            return;
        push(ACT_ROUTE(form.number, actId))
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} style={{overflowX: "auto"}}>
                <Typography color={"textSecondary"}>
                    {label || "Список актов"}
                </Typography>
            </Grid>
            <Grid item xs={12} style={{overflowX: "auto"}}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell variant={"head"} style={cellHeadStyles}>
                                № n/n
                            </TableCell>
                            <TableCell variant={"head"} style={cellHeadStyles}>
                                Номер акта
                            </TableCell>
                            <TableCell variant={"head"} style={cellHeadStyles}>
                                Дата создания
                            </TableCell>
                            <TableCell style={deleteColumnStyles}/>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(fields || []).map((item) => {
                            return (
                                <TableRow key={item.fieldKey}>
                                    <TableCell variant={"head"} style={cellHeadStyles}>
                                        {item.actId}
                                    </TableCell>
                                    <TableCell variant={"head"} style={cellHeadStyles}>
                                        {item.number}
                                    </TableCell>
                                    <TableCell variant={"head"} style={cellHeadStyles}>
                                        {formatDate(item.createdAt, MOMENT_FORMAT_DATE_DMY_DOTS)}
                                    </TableCell>
                                    <TableCell align={"right"} style={deleteColumnStyles}>
                                        <Button size="large" onClick={() => handleGoToAct(item.actId)} variant="contained">
                                            Смотреть
                                        </Button>
                                        <IconButton disabled={disabled}
                                            onClick={() => deleteActHandler(item.actId)}
                                        >
                                            <HighlightOff/>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </Grid>
            <Button sx={{marginTop: '20px', marginLeft: "15px"}} size="large" onClick={() => setOpen(true)} disabled={disabled}
                    variant={"contained"}>
                Выбрать акт / направление
            </Button>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                maxWidth={"80%"}
            >
                <DialogTitle>Выбор акта / направления</DialogTitle>
                <Divider/>
                <DialogContent>
                    <ActCRUDTable
                        extraFilter={governmentActsOnly ? RESOLUTION_ATTACHMENT_EXTRA_FILTER : undefined}
                        extraQuery={governmentActsOnly ? {includes: ['Form', 'FilialDivision']} : undefined}
                        onClickDetailsButton={undefined} // что бы не показывать кнопку создания
                        onClickCreateButton={undefined} // что бы не показывать кнопку создания
                        onRowClick={async (record) => {
                            if (governmentActsOnly && !isEligibleForResolutionAttachment(record)) {
                                alert.show(
                                    0,
                                    'К постановлению можно прикрепить акт госзаказа или направление.'
                                );
                                return;
                            }

                            const response = await resolutionActCRUD.search({
                                paging: {
                                    skip: 0,
                                    take: 1
                                },
                                filter: {
                                    actId: {
                                        operand1: record.id,
                                        operator: 'equals'
                                    }
                                }
                            });
                            const result = response.result;

                            if (result.some(r => r.resolutionId)) {
                                alert.show(0, 'Выбранный документ уже добавлен в другое постановление');
                                return;
                            }                            

                            onChangeFilial(record?.filialId)
                            onChangeFilialDivision(record?.filialDivisionId)
                            if (record.data) {
                                const actParsing = JSON.parse(record.data)
                                if (actParsing?.object) {
                                    onChange(actParsing?.object?.value)
                                }
                            }
                            append({...record, id: 0, actId: record.id});
                            setOpen(false);
                        }}
                    />
                </DialogContent>
                <Divider/>
                <DialogActions>
                    <Button
                        variant={"text"}
                        style={{marginLeft: "auto"}}
                        onClick={() => setOpen(false)}
                    >
                        Отменить
                    </Button>
                </DialogActions>
            </Dialog>
            <FormHelperText error sx={{p: 2}}>
                {error?.message ? error?.message : null}
            </FormHelperText>
            {alert.render()}
        </Grid>
    );
}

export default RHFActField;
